import { faUser } from '@fortawesome/pro-solid-svg-icons';

import { IconBadge, IconBadgeUse, Text } from '@growtherapy/sprout-ui';

import { Toast, ToastRenderFnProps } from '../../toasts';
import { noop } from '../../utils';
import { AutomaticallyTransferringTextWrapper as AutomaticallyTransferringText } from './AutomaticallyTransferringText';

type ClientFinishingUpToastProps = Omit<ClientFinishingUpToastWrapperProps, 'visitorId'> & {
  countdownComponent: React.ReactNode;
};

export function ClientFinishingUpToast({
  countdownComponent,
  contentProps,
  titleProps,
  onOpenQueue = noop,
  participantName,
  ...toastAriaProps
}: ClientFinishingUpToastProps) {
  return (
    <Toast className='sm:w-[30rem]' data-testid='client-finishing-up-toast' {...toastAriaProps}>
      <button className='flex items-center flex-1 gap-3' onClick={onOpenQueue} aria-label='Open client queue'>
        <IconBadge aria-hidden icon={faUser} use={IconBadgeUse.Lilac} size='lg' />
        <div className='flex flex-col'>
          <div {...contentProps}>
            <Text
              as='span'
              variant='sm'
              className='text-left fs-exclude font-medium'
              data-dd-privacy='mask'
              data-dd-action-name='Click on client finishing up toast title'
              {...titleProps}
            >
              {participantName} is finishing up in the waiting room
            </Text>
          </div>
          {countdownComponent}
        </div>
      </button>
    </Toast>
  );
}

type ClientFinishingUpToastWrapperProps = {
  visitorId: string;
  participantName: string;
  onOpenQueue?: () => void;
} & ToastRenderFnProps;

export function ClientFinishingUpToastWrapper(props: ClientFinishingUpToastWrapperProps) {
  return (
    <ClientFinishingUpToast
      countdownComponent={<AutomaticallyTransferringText visitorId={props.visitorId} onFinish={props.closeToast} />}
      {...props}
    />
  );
}
